module.exports = __webpack_public_path__ + "static/media/N6.fd7317d8.png";